var _path, _mask, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabelEcoFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 1.5C6.544 1.5.754 2.89 2.607 8.912c6.67 2.594 7.411-4.17 7.643-7.412z",
    fill: "#7CA848"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 1.5C6.544 1.5.754 2.89 2.607 8.912c6.67 2.594 7.411-4.17 7.643-7.412z",
    fill: "#7CA848"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.5h-1c-.5-13 5.5-10.5 8.5-9-3.6 2-7.75 8-7.5 9z",
    fill: "#B8E484"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.5h-1c2.25-5 5.3-7.4 8.5-9-3.6 2-7.75 8-7.5 9z",
    fill: "#548020"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelEcoFriendly);
export default __webpack_public_path__ + "static/media/label_eco_friendly.3a2b68875bf68d1e7cff3e5017e3e0cf.svg";
export { ForwardRef as ReactComponent };